
const ENDPOINT_PONO = '/api/master/po/'
const ENDPOINT_POLINE = '/api/master/po/poLine/'
const ENDPOINT_ITEMNO = '/api/master/jdeItem/'
const ENDPOINT_UPLOAD_ATTACHMENT = '/api/material/attachment/file'
const ENDPOINT_UPLOAD_MFD_ATTACHMENT = '/api/material/mfd/attachment/file'
const ENDPOINT_UPLOAD_ISSUE_CLEANING_ATTACHMENT = '/api/material/issueitem/file'
const ENDPOINT_UPLOAD_INVOICE_ATTACHMENT = '/api/material/invoice/attachment/file'
const ENDPOINT_UPLOAD_CLEANING_ATTACHMENT = '/api/material/cleaningitem/file'
const ENDPOINT_UPLOAD_MAINTENANCE_ATTACHMENT = '/api/maintenance/item/attachment/file'
const ENDPOINT_UPLOAD_RECEIVE_CONTAMINATE_ATTACHMENT = '/api/material/receive/contaminate/file'
const ENDPOINT_IMPORT_RMR = '/api/material/import/rmrtemplate/'
const ENDPOINT_IMPORT_JDECHILD = '/api/material/import/jdechild'
const ENDPOINT_IMPORT_FINALREFURBISH = '/api/maintenance/import/finalrefurbish/'
const ENDPOINT_WONO = '/api/master/workorder/'
const ENDPOINT_AFENO = '/api/master/afeno/'
const ENDPOINT_PARTNUMBER = '/api/master/partnumber/'
const ENDPOINT_MANUFACTURER = '/api/master/manufacturer/'
const ENDPOINT_BRANCHPLANT = '/api/master/branchplant/'
const ENDPOINT_BINLOCATION = '/api/master/binlocation/'
const ENDPOINT_JUSTIFICATION = '/api/master/justification/'
const ENDPOINT_MODIFY_TYPE = '/api/master/modifytype/'
const ENDPOINT_UOM = '/api/master/uom/'
const STATUS_VALUE = {
  ACTIVE: 'AV',
  INACTIVE: 'IN'
}
const RMR_STATUS = {
    DRAFTS: 0,
    SUBMIT: 1,
    APPROVE: 2,
    CANCEL: 3,
    REJECT: 4,
    WITHDRAW: 5,
}
const RETURN_TYPE= {
  SURPLUS : 1,
  COURTESY : 2,
  DISPOSAL : 3,
  REPAIR_RETURN: 8,
  CONTAMINATE: 9
}
const RMR_ITEM_STATUS = {
  PENDING: 0,
  REVIEW: 1,
  CANCEL: 2
}
const PO_CURRENCY = {
  THB: 'THB',
  USD: 'USD'
}
const LOCATION_TYPE = {
  ONSHORE_LOCATION: 1,
  PLATFORM_LOCATION: 2,
  ASSIGN_LOCATION: 3,
  BUYER_LOCATION: 4
}
const MATERIAL_SOURCE = [
  {label: 'Import', value: 'Import'},
  {label: 'Local', value: 'Local'}
]
const STOCK_TYPE = {
  STOCK: 'Stock',
  NON_STOCK: 'Non-Stock'
}
const MATERIAL_STOCK = [
  {label: 'Stock' , value: 'Stock'},
  {label: 'Non-Stock' , value: 'Non-Stock'}
]
const MATERIAL_TYPE = [
  {label: 'contaminate' , value: 'contaminate'},
  {label: 'non-contaminate' , value: 'non-contaminate'},
]
const MAINTENANCE_TYPE_JUSTINTIME =  {label: 'Just in Time' , value: '1'}
const MAINTENANCE_TYPE_RETURNINV =   {label: 'Return to Inventory' , value: '2'}
const MAINTENANCE_TYPE_ONDEMAND =   {label: 'On Demand' , value: '3'}
const MAINTENANCE_TYPE = [
  MAINTENANCE_TYPE_JUSTINTIME,
  MAINTENANCE_TYPE_RETURNINV,
  // MAINTENANCE_TYPE_ONDEMAND
]
const MAINTENANCE_ITEM_TYPE = {
  NORMAL: 1,
  FOR_DISPOSAL: 2,
}
const MAINTENANCE_STATUS = {
  DRAFT: 0,
  READY_TO_SHIP: 1,
  DELIVER_TO_SUPPLIER: 2,
  INPROGRESS: 3,
  COMPLETED: 4,
  COMPLETED_ADJUSTMENT: 5,
  APPROVED: 6,
  ASSIGNED_LOCATION: 7,
  SEND_TO_DESTINATION: 7,
  CANCELLED: 99
}
const MAINTENANCE_STATUS_DISPLAY = {
  DRAFT: 'Draft',
  READY_TO_SHIP: 'Ready to Ship',
  DELIVER_TO_SUPPLIER: 'Material in transit',
  INPROGRESS: 'Repair in progress',
  APPROVED: 'Approved',
  ASSIGNED_LOCATION: 'Assigning location',
  SEND_TO_DESTINATION: 'Send to destination',
  COMPLETED: 'Waiting approval',
  COMPLETED_ADJUSTMENT: 'Adjustment completed',
  RECEIVED_AT_DESTINATION : 'Received at destination',
  CANCELLED: 'Cancelled'
}
const MAINTENANCE_STATUS_DISPLAY_MFD = {
  DRAFT: 'Draft',
  COMPLETED: 'Completed'
}
const MFD_STATUS = {
  INPROGRESS: 1,
  REVIEW: 2,
  APPROVE: 3,
  COMPLETE_FINANCESUP: 7,
  COMPLETE_PARTNER: 8,
  COMPLETE_CUSTOMDETAIL: 9,
  COMPLETE_PHYSICALMOVE: 10,
  COMPLETE_PARTNERREVIEW: 11,
}
const MFD_TYPE = {
  DMF: '1',
  STOCK: '2',
  NON_STOCK: '3'
}
const MFD_ATTACHMENT_TYPE = {
  DMF: 1,
  CUSTOM_DETAIL: 2,
  PHYSICAL_MOVE: 3,
  PARTNER_REVIEW: 4,
  MFD_DETAIL: 5
}

const MFD_ATTACHMENT_TYPE_DISPLAY = {
  DMF: 'dmf',
  CUSTOM_DETAIL: 'custom',
  PHYSICAL_MOVE: 'physical',
  PARTNER_REVIEW: 'partner',
  MFD_DETAIL: 'detail'
}

const USER_ROLE = {
  GUEST: 999,
  REQUESTER: 1,
  APPROVER: 2,
  FINANCE_STOCK: 3,
  INVENTORY_SPECIALIST: 4,
  DOA_APPROVER: 5,
  FINANCE_SUP: 6,
  STOCK_ADJ: 7,
  PARTNER:8,
  WH_DISPOSAL: 9,
  PGPA: 10,
  ADMIN: 99,
  CUSTOM: 11,
  PHYSICAL_MOVE: 12,
  WH_SURPLUS: 13,
  FINANCE_NONSTOCK: 14,
  INVOICE_APPROVER: 15,
  FINANCE_AR: 16,
  INVENTORY_WF: 17,
  INVENTORY_WF_SUP: 18,
  OWS: 19,
  WESTE_CONTRACTOR: 20,
  BUYER: 21,
  OWS_SUP: 22
}

const USER_ROLE_DISPLAY = {
  REQUESTER: 'Requestor',
  APPROVER: 'Approver',
  FINANCE: 'Finance',
  INVENTORY_SPECIALIST: 'Inventory Specialist',
  DOA_APPROVER: 'Approver',
  FINANCE_SUP: 'Finance Sup',
  STOCK_ADJ: 'Stock Adjustment',
  PARTNER: 'Partner',
  WH: 'Warehouse',
  PGPA: 'PGPA',
  ADMIN: 'Admin'
}

const USER_ROLE_TYPE = {
  APPROVER_MAIL_GROUP: 1
}

const APPROVAL_STATUS = {
  APPROVED: 'Approved',
  PREPARED_MFD: 'Prepared MFD'
}

const RECEIVED_DATE_SELECTED_STATUS = {
  UNRECEIVED: 0,
  RECEIVED: 1,
  SUBMITTED: 2
}

const RMR_STATUS_DISPLAY = {
  0: 'Completed',
  1: 'Pending receive',
  2: 'Pending review',
  3: 'Received',
  4: 'Pending confirm'
}

const RMR_ITEM_STATUS_DISPLAY = {
  0: 'Pending receive',
  1: 'Received',
  2: 'Completed'
}

const INVOICE_STATUS = {
  DRAFT: 0,
  INPROGRESS: 1,
  REVIEW: 2,
  APPROVE: 3,
  FINANCE_AR: 4
}

const REPAIR_RETURN_ITEM_STATUS = {
  RECEIVED_AT_OWS: 0,
  DELIVER_EQUIPMENT_TO_SUPPLIER: 1,
  REPAIR_IN_PROGRESS: 2,
  RECEIVED_REFURBISHED_EQUIPMENT: 3,
  COMPLETED_INVENTORY_ADJUSTMENT: 4,
  CANCELLED: 5
}

const SELL_OPTION = {
  LUMPSUM: {
    Text: 'Lumpsum',
    Value: 1
  },
  SELL_PER_KG:  {
    Text: 'Sell per KG.',
    Value: 2
  },
}

const CLEANING_STATUS_DISPLAY = {
  DRAFT: 'Draft',
  RECEIVE_PENDING: 'Pending Receive',
  COMPLETED: 'Completed'
}

const CLEANING_STATUS_VALUE = {
  DRAFT: 0,
  RECEIVE_PENDING: 1,
  COMPLETED: 2
}

const CLEANING_TYPE = {
  ISSUE: 1,
  RECEIVE: 2
}

const CLEANING_ATTACHMENT_TYPE = {
  CLEANING: 1,
  MANIFEST: 2
}
const BUYER_CHEVRON_ID = 1

const MAINTENANCE_EQUIP_STATUS_DISPLAY = {
  RECEIVED_AT_OWS: 'Received at OWS',
  IN_PROGRESS: 'In progress',
  COMPLETED: 'Completed',
}

const MFD_OBJECTIVE_VALUE = {
  DONATE: 0,
  ELIMINATE: 1,
  SELL: 2
}

const INVOICE_CURRENCY = {
  USD: 'USD',
  THB: 'THB'
}

const CHEVRON_COMPANY_CODE = 'CHEVRON'

export default {
  ENDPOINT: {
    WONO: ENDPOINT_WONO,
    AFENO: ENDPOINT_AFENO,
    PONO: ENDPOINT_PONO,
    POLINE: ENDPOINT_POLINE,
    ITEMNO: ENDPOINT_ITEMNO,
    UPLOAD_ATTACHMENT: ENDPOINT_UPLOAD_ATTACHMENT,
    IMPORTRMR: ENDPOINT_IMPORT_RMR,
    IMPORTJDECHILD: ENDPOINT_IMPORT_JDECHILD,
    IMPORT_FINALREFURBISH: ENDPOINT_IMPORT_FINALREFURBISH,
    ENDPOINT_UPLOAD_MFD_ATTACHMENT: ENDPOINT_UPLOAD_MFD_ATTACHMENT,
    ENDPOINT_UPLOAD_INVOICE_ATTACHMENT: ENDPOINT_UPLOAD_INVOICE_ATTACHMENT,
    ENDPOINT_UPLOAD_CLEANING_ATTACHMENT: ENDPOINT_UPLOAD_CLEANING_ATTACHMENT,
    ENDPOINT_UPLOAD_MAINTENANCE_ATTACHMENT: ENDPOINT_UPLOAD_MAINTENANCE_ATTACHMENT,
    ENDPOINT_UPLOAD_ISSUE_CLEANING_ATTACHMENT: ENDPOINT_UPLOAD_ISSUE_CLEANING_ATTACHMENT,
    ENDPOINT_UPLOAD_RECEIVE_CONTAMINATE_ATTACHMENT: ENDPOINT_UPLOAD_RECEIVE_CONTAMINATE_ATTACHMENT,
    PARTNUMBER: ENDPOINT_PARTNUMBER,
    MANUFACTURER: ENDPOINT_MANUFACTURER,
    BRANCHPLANT: ENDPOINT_BRANCHPLANT,
    BINLOCATION: ENDPOINT_BINLOCATION,
    JUSTIFICATION: ENDPOINT_JUSTIFICATION,
    MODIFY_TYPE: ENDPOINT_MODIFY_TYPE,
    UOM: ENDPOINT_UOM
  },
  RMR_STATUS: RMR_STATUS,
  RETURN_TYPE: RETURN_TYPE,
  PO_CURRENCY: PO_CURRENCY,
  LOCATION_TYPE: LOCATION_TYPE,
  RMR_ITEM_STATUS: RMR_ITEM_STATUS,
  // for select option option
  MATERIAL_SOURCE: MATERIAL_SOURCE,
  MATERIAL_STOCK: MATERIAL_STOCK,
  MATERIAL_TYPE: MATERIAL_TYPE,
  MAINTENANCE_TYPE: MAINTENANCE_TYPE,
  MFD_STATUS: MFD_STATUS,
  MFD_TYPE: MFD_TYPE,
  APPROVAL_STATUS: APPROVAL_STATUS,
  USER_ROLE: USER_ROLE,
  RECEIVED_DATE_SELECTED_STATUS: RECEIVED_DATE_SELECTED_STATUS,
  STATUS_VALUE: STATUS_VALUE,
  USER_ROLE_DISPLAY: USER_ROLE_DISPLAY,
  RMR_STATUS_DISPLAY: RMR_STATUS_DISPLAY,
  MAINTENANCE_TYPE_JUSTINTIME: MAINTENANCE_TYPE_JUSTINTIME,
  MFD_ATTACHMENT_TYPE: MFD_ATTACHMENT_TYPE,
  MFD_ATTACHMENT_TYPE_DISPLAY: MFD_ATTACHMENT_TYPE_DISPLAY,
  INVOICE_STATUS: INVOICE_STATUS,
  REPAIR_RETURN_ITEM_STATUS: REPAIR_RETURN_ITEM_STATUS,
  SELL_OPTION: SELL_OPTION,
  MAINTENANCE_STATUS: MAINTENANCE_STATUS,
  MAINTENANCE_STATUS_DISPLAY: MAINTENANCE_STATUS_DISPLAY,
  MAINTENANCE_STATUS_DISPLAY_MFD: MAINTENANCE_STATUS_DISPLAY_MFD,
  MAINTENANCE_ITEM_TYPE: MAINTENANCE_ITEM_TYPE,
  CLEANING_TYPE: CLEANING_TYPE,
  CLEANING_ATTACHMENT_TYPE: CLEANING_ATTACHMENT_TYPE,
  CLEANING_STATUS_DISPLAY: CLEANING_STATUS_DISPLAY,
  CLEANING_STATUS_VALUE: CLEANING_STATUS_VALUE,
  RMR_ITEM_STATUS_DISPLAY: RMR_ITEM_STATUS_DISPLAY,
  USER_ROLE_TYPE: USER_ROLE_TYPE,
  BUYER_CHEVRON_ID: BUYER_CHEVRON_ID,
  MAINTENANCE_EQUIP_STATUS_DISPLAY: MAINTENANCE_EQUIP_STATUS_DISPLAY,
  STOCK_TYPE: STOCK_TYPE,
  MFD_OBJECTIVE_VALUE: MFD_OBJECTIVE_VALUE,
  INVOICE_CURRENCY: INVOICE_CURRENCY,
  CHEVRON_COMPANY_CODE
}
